import { isEditMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import {
	getShowAddDependency,
	getDependencyReportStatus,
	getAddDependencyFromIssueId,
	getDependencyFilters,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies';
import { getDependencyIssueLinkTypes } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-links';
import { getIssueTypes } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-types';
import { getIssues } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { getProjectsById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/projects';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { StateProps } from './types';

export default createStructuredSelector<State, StateProps>({
	show: getShowAddDependency,
	reportStatus: getDependencyReportStatus,
	fromIssueId: getAddDependencyFromIssueId,
	issues: getIssues,
	issueTypes: getIssueTypes,
	projectsById: getProjectsById,
	issueLinkTypes: getDependencyIssueLinkTypes,
	isEditMode,
	dependencyFilters: getDependencyFilters,
});
